import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const MaterialIcon = ({type, className, children, tiny, small, medium, large, right, left, ...props}) => (
    <i {...props} className={classNames('material-icons', {tiny, small, medium, large, right, left}, className)}>
        {type || children}
    </i>
);

MaterialIcon.propTypes = {
    type: PropTypes.string,
    children: PropTypes.string,
    className: PropTypes.string,

    /* size classes */
    tiny: PropTypes.bool,
    small: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,

    /* position */
    right: PropTypes.bool,
    left: PropTypes.bool,
};

MaterialIcon.defaultProps = {
    className: null,
    children: null,
    type: null,
    tiny: false,
    small: false,
    medium: false,
    large: false,
    right: false,
    left: false,
};

export default MaterialIcon;



// WEBPACK FOOTER //
// ./scripts/components/MaterialIcon.js